import * as allChains from "viem/chains";

export const getChainName = (chainId: number | string) => {
  const chain = Object.values(allChains).find(
    ({ id }) => id === Number(chainId),
  );
  return chain?.name || "Unknown";
};
